import { createAsyncThunk } from '@reduxjs/toolkit';

import axiosInstance from 'utils/axios';
import { hospitalHeaders } from '@/utils';
import { getErrorMessage } from 'utils/error-message';
/** `GET /ingest-files/last-sync-date` response. `lastSyncDate` is an ISO 8601 UTC datetime. */
export type IngestFilesLastSyncDateResponse = {
    lastSyncDate: string;
};

export type FetchIngestFilesLastSyncDateArg = {
    hospitalId: string;
};
/** `GET /ingest-files/last-sync-date` — header: `X-Hospital-Id`. `lastSyncDate` is UTC. */
export const fetchIngestFilesLastSyncDate = createAsyncThunk<
    IngestFilesLastSyncDateResponse,
    FetchIngestFilesLastSyncDateArg,
    { rejectValue: string }
>('ingestFiles/fetchLastSyncDate', async ({ hospitalId }, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get<IngestFilesLastSyncDateResponse>(
            'ingest-files/last-sync-date',
            hospitalHeaders(hospitalId)
        );
        return data;
    } catch (error: unknown) {
        return rejectWithValue(getErrorMessage(error, 'Failed to fetch ingest files last sync date'));
    }
});
